module.exports = __webpack_public_path__ + "static/media/info-icon.ad53bc52.svg";